import { CustSuppData } from 'src/app/model/customer';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import { UrlMaker } from 'src/app/commons/url-maker';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ServiceUtilsService } from './service-utils.service';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { OperationResult } from '@tb/auth';

@Injectable({ providedIn: 'root' })
export class ProxyService {
    proxyApiUrl: string;
    constructor(private serviceUtilsService: ServiceUtilsService, private http: HttpClient) {
        this.proxyApiUrl = environment.settings.microareaserviceproxy;
    }
    getCalculation(amount: string): Observable<OperationResult> {
        if (!amount) {
            return observableThrowError('The amount is missing!');
        }

        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        let url = `${this.proxyApiUrl}Ecommerce/api/calculation/${amount}`;
        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => ErrorObservable.create(error || 'Server error in getCalculation')));
    }

    getPaiEcommerceRanges(): Observable<OperationResult> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        let url = `${this.proxyApiUrl}Ecommerce/api/ranges`;
        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => ErrorObservable.create(error || 'Server error in getPaiEcommerceRanges')));
    }

    public async getEndUserInformation(userID: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getEndUserInformation');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            authToken: environment.auth.authToken,
            userID: userID,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public async getEndUsersByReseller(userID: string, resellerID: string, userTypeFilter: number): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getEndUsersByReseller');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            userID: userID,
            authToken: environment.auth.authToken,
            resellerID: resellerID,
            userTypeFilter: userTypeFilter,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public async getAllSupportContacts(userID: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getAllSupportContacts');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            userID: userID,
            authToken: environment.auth.authToken,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public async getActivationsDetailsByUser(accountID: string, customerID: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getActivationsDetailsByUser');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            accountID: accountID,
            authToken: environment.auth.authToken,
            userID: customerID,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public async checkFiles(uploadedFiles: File[]): Promise<OperationResult> {
        const uploadData = new FormData();
        for (let i = 0; i < uploadedFiles.length; i++) {
            let file = uploadedFiles[i];
            uploadData.append('uploadedFiles', file, file.name);
        }
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('checkFiles');

        return this.http.post<OperationResult>(url.toString(), uploadData).toPromise();
    }

    public async getAllUserDocs(userID: string, subscriptionKey: string): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('getUserDocs')
            .appendSegment(userID) //27364
            .appendSegment(subscriptionKey); //'SUB-22-D0B84E'

        return this.http.get<OperationResult>(url.toString()).toPromise();
    }

    public async getResellerCompanyName(partnerCode: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getResellerCompanyName');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            authToken: environment.auth.authToken,
            partnerCode: partnerCode,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    // public async getItemDescription(item: string): Promise<OperationResult> {
    //     const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getItemDescription');

    //     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     const jobj = {
    //         authToken: environment.auth.authToken,
    //         item: item,
    //     };
    //     return this.http
    //         .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
    //             headers: headers,
    //         })
    //         .toPromise();
    // }

    // public async getInternationalItemDescription(item: string, language: string): Promise<OperationResult> {
    //     const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('getInternationalItemDescription');

    //     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     const jobj = {
    //         authToken: environment.auth.authToken,
    //         item: item,
    //         language: language,
    //     };
    //     return this.http
    //         .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
    //             headers: headers,
    //         })
    //         .toPromise();
    // }
}
